import { Component, Inject, OnInit } from '@angular/core';
import { IModifySearch } from '@core/models/modals';
import { MB_DIALOG_DATA, MbBasicDialog, MbDialogHeader, MbDialogBody, MbStarsRating, MbAlert } from '@am/moebius';
import { DeviceService } from '@core/services/device.service';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { SearchWidgetComponent } from '@commons/search-widget/search-widget.component';

@Component({
  selector: 'app-modal-modify-search',
  standalone: true,
  imports: [MbBasicDialog, MbDialogHeader, MbDialogBody, MbStarsRating, MbAlert, SearchWidgetComponent],
  templateUrl: './modify-search.component.html',
  styleUrls: ['./modify-search.component.scss'],
})
export class ModalModifySearchComponent extends DialogWrapperComponent implements OnInit {
  isMobile: boolean;

  constructor(
    private deviceService: DeviceService,
    @Inject(MB_DIALOG_DATA) public dialogData: IModifySearch,
  ) {
    super();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    super.ngOnInit();
  }
}
